import styled from 'styled-components';

const SearchWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  padding: 16px 0;
  @media screen and (max-width: 992px) {
    justify-content: flex-start;
  }
`;

export default SearchWrapper;
